import React, { Component } from 'react';

import {
    Content,
    Label,
    Section,
    TelevisionStyled,
    Text,
    Title,
} from  './styled';
export default class SectionFunctions extends Component {
    render() {
        const { activeSlide, prevSlide, breakpoint, ...props } = this.props;

        const isActive = (activeSlide.link === 'archive');
        const from = (isActive) ? prevSlide.link : null;
        const to = (!isActive) ? activeSlide.link : null;

        return (
            <Section isActive={isActive} from={from} to={to} {...props}>
                <Content>
                    <Title>Пропустили любимый сериал? Найдите его в&nbsp;архиве.</Title>
                    <Text>Все передачи записываются в архив. Смотрите&nbsp;то, что было на&nbsp;ТВ за&nbsp;последние 7&nbsp;дней.</Text>
                </Content>

                <Label>*На странице использован интерфейс приставки Movix Pro</Label>
                <TelevisionStyled breakpoint={breakpoint} mod='sectionArchive' isPlay={isActive}/>
            </Section>
        );
    }
}
